'use strict';
import loadScript from '../libs/@elements/load-script';

const client_name = 'deuter';
const site_ID = 'main_site';
const locale = window['_config'].locale || "de_AT";

let bazaarLoaded = false;

export function init () {
    if(!bazaarLoaded && !window.$BV){
        loadScript("https://apps.bazaarvoice.com/deployments/" + client_name + "/" + site_ID + "/production/" + locale + "/bv.js").then(() => {
            bazaarLoaded = true;

            if (window.loadBazaarvoiceFnc) {
                window.loadBazaarvoiceFnc.forEach(fnc => fnc());
            }
        }).catch(console.error);
    }
}
